// components/transaction-forms/TransferFormFields.js
import React from "react";
import { Form, Row, Col, Alert, Card } from "react-bootstrap";
import { ErrorMessage } from "formik";
import { formatINR } from "../../helpers";

const TransferFormFields = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  accounts,
  selectedAccountBalance,
  receiverAccountBalance,
  handleAccountChange,
  t,
}) => {
  const isAmountExceedsBalance =
    values.transferAmount &&
    parseFloat(values.transferAmount) > selectedAccountBalance;
  const availableReceiveAccounts = accounts.filter(
    (account) => account.id != values.fromBankAccount
  );

  return (
    <>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>{t("transaction.form.currentBalance")}</Form.Label>
            <Form.Control
              type="text"
              value={formatINR(selectedAccountBalance)}
              disabled
              className="bg-light"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label className="required">
              {t("transaction.form.toBankAccount")}
            </Form.Label>
            <Form.Select
              name="toBankAccount"
              value={values.toBankAccount}
              onChange={(e) =>
                handleAccountChange(
                  e.target.value,
                  setFieldValue,
                  "toBankAccount"
                )
              }
              onBlur={handleBlur}
              isInvalid={touched.toBankAccount && !!errors.toBankAccount}
              disabled={!values.fromBankAccount}
            >
              <option value="">{t("transaction.form.selectAccount")}</option>
              {availableReceiveAccounts.map((account) => (
                <option key={account.id} value={account.id}>
                  {account?.bankName || "Cash Account"} - {account.accountNumber} (₹
                  {account.balance})
                </option>
              ))}
            </Form.Select>
            <ErrorMessage
              name="toBankAccount"
              component="div"
              className="text-danger small mt-1"
            />
          </Form.Group>
        </Col>
      </Row>

      {values.toBankAccount && (
        <Row className="mb-3">
          <Col md={12}>
            <Card className="bg-light border-0">
              <Card.Body className="py-2">
                <small className="text-muted">
                  {t("transaction.form.receiverCurrentBalance")}: ₹
                  {receiverAccountBalance.toFixed(2)}
                </small>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {isAmountExceedsBalance && (
        <Alert variant="danger" className="mb-3">
          <i className="ri-error-warning-line me-2"></i>
          {t("transaction.validation.insufficientBalanceWarning")}
        </Alert>
      )}

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label className="required">
              {t("transaction.form.transferAmount")}
            </Form.Label>
            <Form.Control
              type="number"
              name="transferAmount"
              value={values.transferAmount}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={touched.transferAmount && !!errors.transferAmount}
              placeholder="0.00"
              step="0.01"
              min="0.01"
              max={selectedAccountBalance}
            />
            <Form.Text className="text-muted">
              {t("transaction.form.maxAmount")}: {formatINR(selectedAccountBalance)}
            </Form.Text>
            <ErrorMessage
              name="transferAmount"
              component="div"
              className="text-danger small mt-1"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>{t("transaction.form.remarks")}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="remarks"
              value={values.remarks}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={touched.remarks && !!errors.remarks}
              placeholder={t("transaction.form.remarksPlaceholder")}
              maxLength={500}
            />
            <ErrorMessage
              name="remarks"
              component="div"
              className="text-danger small mt-1"
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default TransferFormFields;
